import { SUGGESTIONS_QUICK_ACTIONS_ORDER } from "app/pages/sales-intelligence/modules/suggestions/constants";
import { SuggestionQuickActionType } from "app/pages/sales-intelligence/modules/suggestions/types/enums";
import siNavigator from "app/pages/sales-intelligence/services/siNavigator";

export const getSuggestedAction = (type: SuggestionQuickActionType, customActions: Record<string, VoidFunction>) => {
    switch (type) {
        case SuggestionQuickActionType.FindProspects:
            return () => siNavigator.goToAdvancedSearchPage();
        case SuggestionQuickActionType.PrepareForMeeting:
            return () => siNavigator.goToAIAgentMeetingRoom();
        case SuggestionQuickActionType.CraftEmail:
            return () => siNavigator.goToAIAgentCraftEmail();
        case SuggestionQuickActionType.EnrichCompanies:
            return () => siNavigator.goToEnrichmentPage();
        case SuggestionQuickActionType.ScoringCriteria:
            return () => siNavigator.goToScoreSettingsPage();
        case SuggestionQuickActionType.CreateList:
            return customActions[SuggestionQuickActionType.CreateList];
    }
};

export const sortByConfigOrder = (inputArray: readonly string[]) => {
    return inputArray
        .filter((item) => SUGGESTIONS_QUICK_ACTIONS_ORDER.hasOwnProperty(item))
        .sort((a, b) => {
            const orderA = SUGGESTIONS_QUICK_ACTIONS_ORDER[a];
            const orderB = SUGGESTIONS_QUICK_ACTIONS_ORDER[b];

            if (orderA < orderB) {
                return -1;
            }
            if (orderA > orderB) {
                return 1;
            }
            return 0;
        });
};
